package br.com.texeratx.boardgametimeapp.ui.screens.forgot_password

import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.domain.usecases.login.ForgotPasswordUseCase
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class ForgotPasswordViewModel(
    private val forgotPasswordUseCase: ForgotPasswordUseCase,
    private val lang: LanguageManager
) : ScreenModel {

    var state = MutableStateFlow(ForgotPasswordUiState())
        private set

    fun updateEmail(v: String) {
        state.value = state.value.copy(email = v)
    }

    fun submit() {
        screenModelScope.launch {
            val s = state.value

            if (s.email.isBlank()) {
                state.value = s.copy(error = lang.strings.value.emailRequired)
                return@launch
            }

            state.value = s.copy(isLoading = true, error = null)

            val result = forgotPasswordUseCase(s.email)

            result.fold(
                onSuccess = {
                    Napier.d("ForgotPasswordViewModel → email enviado com sucesso")
                    state.value = state.value.copy(isLoading = false, isSuccess = true)
                },
                onFailure = { e ->
                    Napier.e("ForgotPasswordViewModel → erro", e)
                    state.value = state.value.copy(
                        isLoading = false,
                        error = e.message ?: lang.strings.value.unknownError
                    )
                }
            )
        }
    }
}
